import { useQuery } from '@tanstack/react-query';
import { businessUnitService, BusinessUnit } from '@/services/businessUnitService';

export const useBusinessUnits = () => {
  return useQuery({
    queryKey: ['businessUnits'],
    queryFn: () => businessUnitService.getAll().then(res => res.data),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const useBusinessUnit = (id: number) => {
  return useQuery({
    queryKey: ['businessUnits', id],
    queryFn: () => businessUnitService.getById(id).then(res => res.data),
    enabled: !!id,
  });
};

export const useBusinessUnitSearch = (search: string, limit: number = 20) => {
  return useQuery({
    queryKey: ['businessUnits', 'search', search, limit],
    queryFn: () => businessUnitService.search(search, limit).then(res => res.data),
    staleTime: 30 * 1000, // 30 seconds for search results
    placeholderData: (previousData) => previousData, // Keep previous data while fetching
  });
};

// Export the type for use in components
export type { BusinessUnit };
